import { createActionGroup, props } from '@ngrx/store';

export const SettingsActions = createActionGroup({
  source: 'Settings',
  events: {
    experimentalMode: props<{ enable: boolean }>(),
  },
});
